// @ts-ignore @types/react-native-web-lottie is not existing and not necessary
export { default } from 'react-native-web-lottie'
